import { Right, type User } from "@/services/user";
import { computed, readonly, ref } from "vue";

const user = ref<User>();

export function useUser() {
  const hasRight = (right: Right): boolean => {
    return user.value?.rights.includes(right) ?? false;
  };

  // Just a temp shortcut until new Marketplace is not for everybody
  const isMarketplace2Enabled = computed(() => {
    return hasRight(Right.Marketplace2_0);
  });

  const isUserLoggedIn = computed(() => user.value !== undefined);

  return {
    user,

    hasRight,
    isMarketplace2Enabled,
    isUserLoggedIn: readonly(isUserLoggedIn),
  };
}
